<template>
  <div style="padding: 50px">
    <el-descriptions title="系統信息" direction="horizontal" :column="1">
      <el-descriptions-item label="系統名稱">S'IM</el-descriptions-item>
      <el-descriptions-item label="系統版本">{{ this.version }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import packageJson from "../../../package.json";

export default {
  name: "SystemInfo",
  data() {
    return{
      version:'1.0.0'
    }
  },
  mounted() {
    this.version=packageJson.version
  }
}

</script>

<style scoped lang="scss">

</style>